﻿import $ from "jquery";

function scrollToAccordion() {
    var accordionSection = window.location.hash;
    if (accordionSection.length && accordionSection.startsWith("#accordion")) {
        var accordionContent = document.querySelector(accordionSection);
        var accordionElement = accordionContent.previousElementSibling;
        if (accordionContent.getAttribute("aria-hidden") === "true") {
            accordionElement.click();
        }
        window.scrollTo(0, accordionElement.offsetTop);
    }
    else if (accordionSection.length) {
        if (accordionSection !== "#top") {
            var contentOffset = $(accordionSection).offset();
            window.scrollTo(0, contentOffset.top - 45);
        }
    }
}

Modernizr.on('csshyphens', function (result) {

    if (window.location.hash) {        
        scrollToAccordion();
    }

});

window.addEventListener('hashchange', function () {
    if (window.location.hash) {
        scrollToAccordion();
    }
});


//////////////////
// WEBPACK FOOTER
// ./Scripts/utils/accordionHelper.js
// module id = 15
// module chunks = 1